import React from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData } from '@wix/da-bi/pkg/events';
const ShareInPost = ({ deviation , shareToPost  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItem, {
        label: t('deviationview.tierCard.moreActionsMenu.item.shareInPost'),
        onClick: shareToPost,
        biData: BiData({
            evid: 356,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            social_share: 'da_post',
            deviationid: deviation.deviationId
        })
    });
};
ShareInPost.displayName = 'ShareInPost';
export default ShareInPost;
